import { useCallback, useMemo, useState } from "react";
var useFnCreateCertificate = function () {
    var _a = useState(), bodyRequest = _a[0], setBodyRequest = _a[1];
    var createCertificate = useCallback(function (data, fileName, typeFile, setTriggerCreate) {
        setBodyRequest({
            title: fileName,
            type: typeFile,
            fileName: fileName,
            html: data,
            physicalName: fileName,
            quickPrintable: false,
        });
        setTriggerCreate(true);
    }, []);
    return useMemo(function () { return ({
        createCertificate: createCertificate,
        bodyRequest: bodyRequest,
    }); }, [createCertificate, bodyRequest]);
};
export default useFnCreateCertificate;
